export enum EmailReminderTriggerType {
  ALL = 'ALL',
  INSPECTION_NOT_STARTED = 'INSPECTION_NOT_STARTED',
  INSPECTION_COMPLETED = 'INSPECTION_COMPLETED',
}

export enum EmailReminderSendNow {
  NOW = 'NOW',
}

export type ListAllEmailReminder = {
  globalEmailSettingId?: string;
  groupId?: string;
};
